import { render, staticRenderFns } from "./SrmCollaboration.vue?vue&type=template&id=d3d967aa&scoped=true"
import script from "./SrmCollaboration.vue?vue&type=script&lang=js"
export * from "./SrmCollaboration.vue?vue&type=script&lang=js"
import style0 from "./SrmCollaboration.vue?vue&type=style&index=0&id=d3d967aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d967aa",
  null
  
)

export default component.exports